var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.summaryInfo)?_c('div',[_c('monitoring-summary',{attrs:{"summaryInfo":_vm.summaryInfo,"pipelineVersion":_vm.pipelineVersion,"cropIdVersion":_vm.cropIdVersion,"yieldestVersion":_vm.yieldestVersion}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }